// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__vQceD"};